module.exports = __webpack_public_path__ + "media/reskin-images/icon--shield-keyhole-active-61cc2723.svg";